import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { cleanRequest } from './cleanRequest'
import { triggersClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useOpenRoutinesModal } from '../../../../utils/routes/modals/modalsActions'
import { validate } from './validate'

const MUTATION = gql`
  mutation UpsertTrigger($input: TriggerInput) {
    upsertTrigger(input: $input) {
      id
    }
  }
`

export const useSaveRoutine = () => {
  const { entities } = useModalData()
  const openList = useOpenRoutinesModal()
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Triggers', 'Folders'], client: triggersClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)

    const { setErrors } = actions
    const isValid = validate(input, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          notify.success({ title: 'Rotina salva com sucesso!!' })
          openList({ entities })
        }
      })
    }
  }

  return [handleRequest, state]
}
